import { render, staticRenderFns } from "./NominationList.vue?vue&type=template&id=7cff2790"
import script from "./NominationList.vue?vue&type=script&lang=js"
export * from "./NominationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports